<template>
    <ComplianceRequirementsSection
        :count="requirements.length"
        :loaded="loaded"
        :show-heading="showRequirementsHeading"
    >
        <RegulationRequirementItem
            v-for="(requirement, index) in requirements"
            :key="requirement.id"
            :number="index + 1"
            :requirement="requirement"
            :context="context"
            :property-config="propertyConfig"
            :show-scip="requirement.scipVisible"
            :scip-required="requirement.scipRequired"
            :scip-number="requirement.scipNumber"
            :collapsible="collapsible"
            :expanded="isExpanded(requirement)"
            :show-substance-requirement-status="showSubstanceRequirementStatus"
            @action="$emit('action', $event)"
            @scip-input="$emit('scip-input', $event)"
            @toggle="toggleRequirement(requirement)"
        />
    </ComplianceRequirementsSection>
</template>

<script>
import ComplianceRequirementsSection from './ComplianceRequirementsSection.vue'
import RegulationRequirementItem from './RegulationRequirementItem.vue'

export default {
    name: 'SimpleProductComplianceOverview',
    components: { ComplianceRequirementsSection, RegulationRequirementItem },
    props: {
        requirements: { type: Array, required: true },
        context: { type: Object, required: true },
        propertyConfig: { type: Object, required: true },
        loaded: { type: Boolean, default: false },
        showRequirementsHeading: { type: Boolean, default: false },
        showSubstanceRequirementStatus: { type: Boolean, default: true },
        requirementDisplay: {
            type: String,
            default: 'expanded',
            validator: value => ['expanded', 'collapsible'].includes(value),
        },
    },
    data() {
        return {
            expandedByRequirementId: {},
        }
    },
    computed: {
        collapsible() {
            return this.requirementDisplay === 'collapsible'
        },
    },
    watch: {
        requirements: {
            immediate: true,
            handler(requirements) {
                requirements.forEach(requirement => {
                    const id = String(requirement.id)

                    if (!Object.prototype.hasOwnProperty.call(this.expandedByRequirementId, id)) {
                        this.$set(
                            this.expandedByRequirementId,
                            id,
                            requirement.status !== 'complete',
                        )
                    }
                })
            },
        },
    },
    methods: {
        isExpanded(requirement) {
            if (!this.collapsible) {
                return true
            }

            return this.expandedByRequirementId[String(requirement.id)] !== false
        },
        toggleRequirement(requirement) {
            if (!this.collapsible) {
                return
            }

            const id = String(requirement.id)
            this.$set(this.expandedByRequirementId, id, !this.isExpanded(requirement))
        },
    },
}
</script>
